/** @module Actions */
import { SET_BACKUP_FOLDERS } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').BackupFolder} BackupFolder
 */

/**
 * @typedef {ReturnType<typeof setBackupFolders>} BackupsActions
 */

/**
 * Sets the backup folders
 * @param {Array<BackupFolder>} folders an array of folder objects
 * @return {{ type: 'SET_BACKUP_FOLDERS', folders: Array<BackupFolder> }}
 */
export const setBackupFolders = (folders) => ({
  type: SET_BACKUP_FOLDERS,
  folders,
})
